import React from 'react';
import { ResumeJourneyType } from './resumeJourney.type';
import styles from './resumeJourneyCard.module.scss';
import Image from 'next/image';
import { classNames } from '@/core/utils/class.utils';
import { useRouter } from 'next/navigation';
import { INTERNAL_LOB } from '@/core/constants/policy.constants';
import { SubHeading } from '@/design-system/text/sub-heading/sub-heading';
import { BodyS } from '@/design-system/text/bodyS/bodyS';
import { PrimaryButton } from '@/design-system/buttons/primary-button/primary-button';

const ResumeJourneyCard = ({
  title,
  description,
  image,
  internalLob,
  route,
}: ResumeJourneyType) => {
  const router = useRouter();
  return (
    <>
      <div
        className={classNames(styles['main-con'], {
          [styles['health-bg']]: internalLob === INTERNAL_LOB.health,
        })}
      >
        {image && (
          <div className={styles['vehicle-image']}>
            <Image src={image} alt={'img'} width={85} height={46} />
          </div>
        )}
        <div className={styles['text-con']}>
          <SubHeading text={title} />
          <BodyS text={description} />
        </div>

        <PrimaryButton
          id="resume-journey-primarys-button-desktop"
          size="small"
          width="fit"
          variant="midnight"
          onClick={() => {
            if (route) {
              router.push(route);
            }
          }}
          text="Continue"
        />
      </div>
      <div
        className={classNames(styles['mobile-view'], {
          [styles['health-bg']]: internalLob === INTERNAL_LOB.health,
        })}
      >
        <div className={styles['text-con']}>
          <SubHeading text={title} />
          <BodyS text={description} />
        </div>
        <PrimaryButton
          id="resume-journey-primarys-button-mobile"
          size="small"
          width="fit"
          variant="midnight"
          onClick={() => {
            if (route) {
              router.push(route);
            }
          }}
          text="Continue"
        />
        <div className={styles['image']}>
          <Image width={65} height={65} src={image} alt={'img'} />
        </div>
      </div>
    </>
  );
};

export default ResumeJourneyCard;
